jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

// 产品卡片配合产品元字段切换图片
const colorItems = document.querySelectorAll('.product-colors-link-wrapper .t4s-pr-color__item');
const handleColorChange = (wrapper) => {
    wrapper.parentNode.querySelectorAll('.t4s-pr-color__item').forEach(sibling => {
        sibling.classList.remove('is-swatch--selected');
    });
    wrapper.classList.add('is-swatch--selected');
    const colorValue = wrapper.querySelector('.t4s-pr-color__value').dataset.bg;
    const imgElement = wrapper.closest('.t4s-product-wrapper').querySelector('.t4s-product-main-img');
    imgElement.srcset = colorValue;
};

// 为每个颜色项添加事件监听
colorItems.forEach(wrapper => {
    wrapper.addEventListener('mouseenter', () => handleColorChange(wrapper));
    wrapper.addEventListener('click', () => handleColorChange(wrapper));
});